import React, { PropTypes } from 'react';
import cx from 'classnames';

export default class Field extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    required: PropTypes.bool,
    number: PropTypes.bool,
    readOnly: PropTypes.bool,
    digits: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.controlError = this.controlError.bind(this);
    this.onChangeEvt = this.onChangeEvt.bind(this);
    this.onBlurEvt = this.onBlurEvt.bind(this);

    this.state = {
      pristine: true,
    };
  }

  controlError(value) {
    const { number, required } = this.props;

    if (required && !value) {
      return true;
    }

    if (number && value && isNaN(value + '0')) {
      return true;
    }

    return false;
  }

  onChangeEvt(evt) {
    const { number, digits, onChange } = this.props;

    if (evt.target.value) {
      const str = evt.target.value;

      if (number && !digits && str.indexOf('.') !== -1 && str !== '') {
        evt.target.value = str.substr(0, str.length - 1);
      } else if (number && str.charAt(str.length - (digits + 2)) === '.') {
        evt.target.value = str.substr(0, str.length - 1);
      } else {
        onChange(evt, this.controlError(evt.target.value));
      }
    } else {
      onChange(evt, this.controlError(evt.target.value));
    }
  }

  onBlurEvt(evt) {
    this.props.onBlur(evt, this.controlError(evt.target.value));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value && this.state.pristine) {
      this.setState({ pristine: false });
    }
  }

  render() {
    const { name, label, value, required, readOnly, number } = this.props;
    // const error = this.controlError(value)
    const pristine = this.state.pristine;

    const divClasses = cx('field', {
      required: required,
      error: value.error && !pristine,
    });

    const inputClasses = cx('ui field', {
      disabled: readOnly,
    });

    return (
      <div className={divClasses}>
        <label>{label}</label>
        <input
          type="text"
          id={name}
          name={name}
          value={value.value}
          required={required}
          className={inputClasses}
          onChange={this.onChangeEvt}
          onBlur={this.onBlurEvt}
          maxLength={!number && '256'}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/common/bill/Field.js